import * as sonbp from "sonbp";
import * as ifbase from "../base";

/**
* ポスカ用描画共通
* @summary 描画オブジェクトの選択描画を行います。
*/
export module drawCommon {

	export var _svg_circle: HTMLImageElement;		//回転アイコン
	export var _svg_resize: HTMLImageElement;		//リサイズアイコン
	export var _svg_blankimg: HTMLImageElement;		//画像未配置アイコン

	(function () {

		//TODO アイコン画像は仮

		//IE11対応
		let f = function (img: HTMLImageElement) {
			if (img.width == 0 || img.height == 0) img.width = img.height = 20;
		};

		_svg_circle = new Image();
		_svg_circle.onload = function () { f(_svg_circle); };
		_svg_circle.src = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent("<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='67' height='67' viewBox='0 0 67 67'><defs><clipPath id='b'><rect width='67' height='67'/></clipPath></defs><g id='a' clip-path='url(#b)'><circle cx='33.5' cy='33.5' r='33.5' fill='#fff'/><path d='M33.5,64.99A31.495,31.495,0,1,0,2,33.5,31.532,31.532,0,0,0,33.5,64.99Z' fill='#444' fill-rule='evenodd'/><g transform='translate(0 0)'><path d='M-99.109-56.791c-.781.721-5.353,5.495-12.5,5.495a20.788,20.788,0,0,1-14.473-5.512,18.713,18.713,0,0,1-5.8-13.746,20.131,20.131,0,0,1,1.657-8.015,19.249,19.249,0,0,1,4.677-6.566,18.149,18.149,0,0,1,6.478-3.824,18.3,18.3,0,0,1,7.487-.853A19.192,19.192,0,0,1-98.472-84.64a19.187,19.187,0,0,1,6.056,12.695h5.943L-91.034-66-95.6-60.048-100.083-66l-4.487-5.949H-98.8a12.872,12.872,0,0,0-4.526-8.471,12.817,12.817,0,0,0-9.157-2.993,12.858,12.858,0,0,0-8.839,4.385,12.852,12.852,0,0,0-3.159,9.345,12.859,12.859,0,0,0,4.067,8.543,12.857,12.857,0,0,0,8.8,3.484h.009a11.262,11.262,0,0,0,8.687-4.008Z' transform='translate(165.237 35.78) rotate(-31)' fill='#fff'/></g></g></svg>")));
		_svg_resize = new Image();
		_svg_resize.onload = function () { f(_svg_resize); };
		_svg_resize.src = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent("<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='67' height='67' viewBox='0 0 67 67'><defs><clipPath id='b'><rect width='67' height='67'/></clipPath></defs><g id='a' clip-path='url(#b)'><circle cx='33.5' cy='33.5' r='33.5' fill='#fff'/><path d='M33.5,64.99A31.495,31.495,0,1,0,2,33.5,31.532,31.532,0,0,0,33.5,64.99Z' fill='#444' fill-rule='evenodd'/><path d='M-89.321,31.676V15.3h16.374l-5.03,5.03,19.356,19.351,5.028-5.028V51.029H-69.97L-64.94,46-84.293,26.648Z' transform='translate(104.957 0.333)' fill='#fff'/></g></svg>")));
		_svg_blankimg = new Image();
		_svg_blankimg.onload = function () { f(_svg_blankimg); };
		_svg_blankimg.src = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent("<svg version='1.1' id='レイヤー_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px'	 y='0px' width='58px' height='58px' viewBox='0 0 58 58' enable-background='new 0 0 58 58' xml:space='preserve'><g>	<g>		<circle fill-rule='evenodd' clip-rule='evenodd' fill='#FFFFFF' cx='29' cy='29' r='28.997'/>	</g>	<g>		<linearGradient id='SVGID_1_' gradientUnits='userSpaceOnUse' x1='29.0005' y1='55.9971' x2='29.0005' y2='2.0034'>			<stop  offset='0' style='stop-color:#896F4A'/>			<stop  offset='1' style='stop-color:#AB997F'/>		</linearGradient>		<path fill-rule='evenodd' clip-rule='evenodd' fill='url(#SVGID_1_)' d='M29,55.997c-14.887,0-26.998-12.11-26.998-26.996			C2.002,14.114,14.114,2.003,29,2.003c14.886,0,26.998,12.111,26.998,26.998C55.998,43.887,43.887,55.997,29,55.997z'/>	</g>	<path fill='#FFFFFF' d='M12.002,16.003v27h34v-27H12.002z M42.002,39.003h-26v-19h26V39.003z'/>	<g>		<path fill='#FFFFFF' d='M28.811,32.994c-3.029,0-5.494-2.465-5.494-5.495c0-3.031,2.465-5.496,5.494-5.496			c3.031,0,5.498,2.465,5.498,5.496C34.309,30.529,31.842,32.994,28.811,32.994z'/>		<path fill='#FFFFFF' d='M37.002,38.003c-0.574-2.4-1.746-4.54-3.293-5.916c-1.215,1.332-2.957,2.113-4.898,2.113			c-1.845,0-3.517-0.67-4.722-1.89c-1.442,1.368-2.54,3.292-3.087,5.692H37.002z'/>	</g></g></svg>")));
	})();


	/**
	 * 選択候補となるアイテム枠の描画
	 */
	export function drawCandidate(ifdto: ifbase.ifDto, ctx: CanvasRenderingContext2D, items: sonbp.object.baseItem[]): void {

		if (ifdto.client == ifbase.constants.CLIENT_SP) {
			//SPモードは選択候補枠を描画しない
			return;
		}

		let _v = ifdto.bpView;

		ctx.strokeStyle = _v._stl.selectCandiLineStyle;
		ctx.lineWidth = _v._stl.selectCandiLineBorderWidth / _v._dm.scaleRate;
		ctx.setLineDash(sonbp.util.c2d.csLineDash(_v._stl.selectCandiLineDash, _v._dm.scaleRate));

		for (let i = 0; i < items.length; i++) {

			let item = items[i];

			if (item.info.mode(sonbp.constant.editModeType.OPERATION_NG)) continue;

			_v._dm.pageTransform(item._apply_pageIdx, ctx);

			ctx.beginPath();

			if (item.type == sonbp.constant.itemType.PATH && (item as sonbp.object.pathItem).isStraight) {
				let path = item as sonbp.object.pathItem;
				let mat = sonbp.util.c2d.matrix2(path.matrix, path._apply_pmatrix);
				let pt0 = sonbp.util.c2d.setPointMatrix(path.commands[0].pt(0), mat);
				let pt1 = sonbp.util.c2d.setPointMatrix(path.commands[1].pt(0), mat);
				ctx.moveTo(pt0.x, pt0.y);
				ctx.lineTo(pt1.x, pt1.y);

			} else if (ifbase.util.chkIsPhotobox(item)) {
				// 画像枠なら外接矩形ではなく、クリップパスで描画する
				let clipMatrix = sonbp.util.c2d.matrix2(item.matrix, item._apply_pmatrix);
				let clipCmds = sonbp.util.c2d.setCommandsMatrix(item.clip_item._commands, clipMatrix);
				sonbp.util.c2d.commandDraw(clipCmds, ctx);

			} else {
				let gpt = sonbp.util.c2d.setPointsMatrix(item.points, item._apply_pmatrix);
				ctx.moveTo(gpt[0].x, gpt[0].y);
				ctx.lineTo(gpt[2].x, gpt[2].y);
				ctx.lineTo(gpt[8].x, gpt[8].y);
				ctx.lineTo(gpt[6].x, gpt[6].y);
				ctx.closePath();
			}
			
			ctx.stroke();
		}
	}

	/**
	 * 画像未配置アイコンの描画
	 */
	export function drawBlankBoxIcon(v: sonbp.view, ctx: CanvasRenderingContext2D, box: sonbp.object.groupItem): void {

		ctx.save();

		let sz = (v._stl.editHandleSize / v._dm.scaleRate) * 1.5;
		let pt = box.points[4];
		let rect = new sonbp.type.rectPoint(pt.x - sz, pt.y - sz, pt.x + sz, pt.y + sz);

		ctx.transform(1, 0, 0, -1, 0, (rect.y1 * 2) + rect.height);
		ctx.drawImage(_svg_blankimg, rect.x1, rect.y1, rect.width, rect.height);

		ctx.restore();
	}

	/**
	 * 選択済みとなるアイテム枠の描画（画像枠）
	 */
	export function drawSelectedBox(ifdto: ifbase.ifDto, ctx: CanvasRenderingContext2D, item: sonbp.object.baseItem): void {

		let _v = ifdto.bpView;

		ctx.strokeStyle = _v._stl.clipLineStyle;
		ctx.lineWidth = _v._stl.clipLineBorderWidth / _v._dm.scaleRate
		ctx.setLineDash(sonbp.util.c2d.csLineDash(_v._stl.clipLineDash, _v._dm.scaleRate));

		let clipMatrix = sonbp.util.c2d.matrix2(item.matrix, item._apply_pmatrix);
		let clipCmds = sonbp.util.c2d.setCommandsMatrix(item.clip_item._commands, clipMatrix);
		sonbp.util.c2d.commandDraw(clipCmds, ctx);
		ctx.stroke();
	}

	/**
	 * 選択矩形の描画
	 */
	export function drawRect(ifdto: ifbase.ifDto, ctx: CanvasRenderingContext2D, points: sonbp.type.point[], fill?: boolean, stroke?: boolean): void {

		let _v = ifdto.bpView;

		// 矩形描画
		ctx.save();
		{
			ctx.strokeStyle = _v._stl.selectLineStyle;
			ctx.lineWidth = _v._stl.selectLineBorderWidth / _v._dm.scaleRate
			ctx.setLineDash(sonbp.util.c2d.csLineDash(_v._stl.selectLineDash, _v._dm.scaleRate));
			ctx.fillStyle = _v._stl.editHandleFillStyle;

			ctx.beginPath()
			ctx.moveTo(points[0].x, points[0].y);
			ctx.lineTo(points[2].x, points[2].y);
			ctx.lineTo(points[8].x, points[8].y);
			ctx.lineTo(points[6].x, points[6].y);
			ctx.closePath();
			ctx.stroke();
		}
		ctx.restore();
	}

	/**
	 * リサイズハンドルの描画
	 */
	export function drawResizePoint(ifdto: ifbase.ifDto, ctx: CanvasRenderingContext2D, points: sonbp.type.point[], base_points: sonbp.type.point[], out_points: sonbp.type.point[], isResizeNg: boolean, isAspectNg: boolean): void {

		if (ifdto.client == ifbase.constants.CLIENT_SP) {
			//SPモードは操作アイコンを描画しない
			return;
		}

		if (isResizeNg) return;

		let _v = ifdto.bpView;

		let sz = (_v._stl.editHandleSize / _v._dm.scaleRate) * 1.5;

		ctx.save();
		{
			let pt = ifbase.util.getIconPoint(ifdto, points, 2, sz);
			let rad = sonbp.util.c2d.getRadian(points[4], points[1]);
			ctx.translate(pt.x, pt.y);
			ctx.rotate(rad);

			let rect = new sonbp.type.rectPoint(-sz, -sz, sz, sz);
			ctx.drawImage(_svg_resize, rect.x1, rect.y1, rect.width, rect.height);
		}
		ctx.restore();
	}

	/**
	 * 回転ハンドルの描画
	 */
	export function drawRotatePoint(ifdto: ifbase.ifDto, ctx: CanvasRenderingContext2D, points: sonbp.type.point[], base_points: sonbp.type.point[], out_points: sonbp.type.point[], isRotateNg: boolean): void {

		if (ifdto.client == ifbase.constants.CLIENT_SP) {
			//SPモードは操作アイコンを描画しない
			return;
		}

		if (isRotateNg) return;

		let _v = ifdto.bpView;

		let sz = (_v._stl.editHandleSize / _v._dm.scaleRate) * 1.5;

		ctx.save();
		{
			let pt = ifbase.util.getIconPoint(ifdto, points, 0, sz);
			let rad = sonbp.util.c2d.getRadian(points[4], points[5]);
			ctx.translate(pt.x, pt.y);
			ctx.rotate(rad);

			let rect = new sonbp.type.rectPoint(-sz, -sz, sz, sz);
			ctx.drawImage(_svg_circle, rect.x1, rect.y1, rect.width, rect.height);
		}
		ctx.restore();
	}

}
